import React from 'react';
import ReactDOM from 'react-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import {BrowserRouter as Router, NavLink, Route, Switch, Link, Redirect} from 'react-router-dom';

import registerServiceWorker from './registerServiceWorker';

import Header from './Header';
import Homepage from './Homepage';
import PrivateIslands from './PrivateIslands';
import RomanticIslands from './RomanticIslands';
import PartyIslands from './PartyIslands';
import FamilyIslands from './FamilyIslands';
import Jumeirah from './Jumeirah';
import IslandDetails from './IslandDetails';
import Footer from './Footer';
import LoginSection from './LoginSection';

let history = createBrowserHistory();

// Google Analytics Starts
let dataLayer = window.dataLayer || [];

function gtag() {
    dataLayer.push(arguments);
}

gtag("js", new Date());
gtag("config", 'UA-107947193-1');
// Google Analytics Ends

const Routes = () => (
    <Router>
        <div>
            <div className="wrapper">
                <Header/>

                <div className="content">
                    <Switch>
                        <Route exact={true} path="/" component={Homepage}/>
                        <Route path="/private_islands" component={PrivateIslands}/>
                        <Route path="/romantic_islands" component={RomanticIslands}/>
                        <Route path="/party_islands" component={PartyIslands}/>
                        <Route path="/family_islands" component={FamilyIslands}/>
                        <Route path="/jumeirah" component={Jumeirah}/>
                        <Route exact={true} path="/island/:name" component={IslandDetails}/>
                    </Switch>
                </div>

                <Footer/>
            </div>

            <LoginSection/>

        </div>
    </Router>
);


ReactDOM.render(
    <Routes/>
    , document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js